import { request } from '../../utils/request';

export const getProductsCategories = (query?: string) =>
  request({
    method: 'GET',
    url: `/products/categories${query ? `?query=${query}` : ''}`,
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
